module.exports = __webpack_public_path__ + "static/media/pedro-lastra.4f559a23.jpg";